import { Colors } from '@oy/uicore';
import { SystemIcon } from '@oy/uiicon';
import classNames from 'classnames';
import React from 'react';
import { Padder } from '../../Layout';
import styles from './Alert.module.css';

export const AlertTypes = [
  'primary',
  'secondary',
  'danger',
  'warning',
  'alternative',
] as const;

type AlertProps = {
  title: string | React.ReactNode;
  type: (typeof AlertTypes)[number];
  paddingSize?: 'small';
  showIcon?: boolean;
};

const Alert = ({ title, type, paddingSize, showIcon = true }: AlertProps) => {
  const getIconColors = () => {
    switch (type) {
      case 'secondary':
        return Colors.BLACK100;
      case 'danger':
        return Colors.RED100;
      case 'warning':
        return Colors.YELLOW100;
      case 'alternative':
        return Colors.GREEN100;
      case 'primary':
      default:
        return Colors.BLUE100;
    }
  };

  return (
    <div className={classNames(styles.container, [styles[type]])}>
      <Padder
        horizontal={paddingSize === 'small' ? Padder.Size.S : Padder.Size.XL}
        vertical={paddingSize === 'small' ? Padder.Size.XS : Padder.Size.M}
      >
        <div className={styles.content}>
          {showIcon && (
            <SystemIcon name="exclamation" color={getIconColors()} />
          )}
          {title}
        </div>
      </Padder>
    </div>
  );
};

export default Alert;
